export const chat = {
  list: {
    title: "メッセージ",
    tabAll: "全員",
    tabActive: "会話中",
    tabBookmark: "お気に入り",
    edit: "編集",
    liveNow: "配信中",
    liveStandby: "配信待機中",
    done: "完了",
    markAllRead: "全て既読",
    deleteAll: "全て削除",
    empty: "会話がありません",
    imageSent: "画像を送信しました",
    imageReceived: "画像が届きました",
    videoSent: "動画を送信しました",
    videoReceived: "動画が届きました",
    mediaMark: "メディアあり",
    audioSent: "ボイスメッセージを送信しました",
    audioReceived: "ボイスメッセージが届きました",
    stickerSent: "スタンプを送信しました",
    stickerReceived: "スタンプが届きました",
    confirmMarkAllReadTitle: "全て既読にしますか？",
    confirmMarkAllReadDescription: "全ての会話を既読にします。",
    confirmMarkRead: "既読にする",
    confirmDeleteAllTitle: "全て削除しますか？",
    confirmDeleteAllDescription:
      "全ての会話を削除します。この操作は取り消せません。",
    confirmDelete: "削除する",
    allShown: "すべて表示しました",
    // 検索絞り込み
    searchFiltering: "検索条件で絞り込み中",
    searchClear: "解除",
    searchEmpty: "条件に合う会話がありません",
    searchLoadMore: "さらに読み込む",
    /** coco+ の一覧（ダーク配色・デザイン 2-1 / 2-2） */
    cocoplus: {
      talkedTitle: "💬 あなたが話しかけた子",
      seeAll: "すべて見る",
      showLess: "閉じる",
      approachTitle: "📨 届いたアプローチ",
      approachCount: (args: { count: number }) => `${args.count}`,
      approachUnit: "人",
      nameMeta: (args: { age: number | null; region: string | null }) =>
        [args.age, args.region].filter((v) => v !== null).join("・"),
      matchedPrefix: "条件に合う会話",
      matchedUnit: "件",
      filterSummary: {
        newOnly: "新人のみ",
        video: "ビデオ",
        voice: "音声",
        recentVideoCall: "今すぐ通話可能",
        lovense: "Lovense",
        fleaMarket: "出品中",
        bodyTypes: (args: { count: number }) => `体型${args.count}件`,
        nickname: (args: { nickname: string }) => `「${args.nickname}」`,
      },
    },
    markAllReadError:
      "既読処理に失敗しました。時間をおいて再度お試しください。",
    deleteAllError: "削除に失敗しました。時間をおいて再度お試しください。",
    confirmMarkSelectedReadTitle: "選択した会話を既読にしますか？",
    confirmMarkSelectedReadDescription: "選択した会話を既読にします。",
    markSelectedReadError:
      "既読処理に失敗しました。時間をおいて再度お試しください。",
    confirmDeleteSelectedTitle: "選択した会話を削除しますか？",
    confirmDeleteSelectedDescription:
      "選択した会話を削除します。この操作は取り消せません。",
    deleteSelectedError: "削除に失敗しました。時間をおいて再度お試しください。",
    // 選択バー（上部）
    selectedCount: (args: { count: string | number }) =>
      `${args.count}件選択中`,
    noSelection: "項目を選択",
    // 一括操作プルダウン（3点リーダ）のアクセシブルラベル
    bulkActionsMenu: "一括操作メニュー",
    // 選択操作ボタンラベル（上部選択バー右側。既読にする/削除）
    toolbarMarkRead: "既読にする",
    toolbarDelete: "削除",
    // アイコンボタン下の短縮ラベル（既読アイコンは分かりづらいため添える）
    markReadShort: "既読",
    // 選択操作の成功トースト
    markSelectedReadSuccess: "既読しました",
    deleteSelectedSuccess: "削除しました",
    // 全件操作のローディングオーバーレイ
    bulkDeleteLoadingTitle: "削除中",
    bulkReadLoadingTitle: "既読中",
    bulkLoadingHint: "そのままお待ちください",
    bulkDeleteDoneTitle: "削除しました",
    bulkReadDoneTitle: "既読しました",
  },
  room: {
    placeholder: "相手のことをほめてみよう",
    /** coco+ の会話画面（ダーク配色・デザイン 2-4〜2-7） */
    cocoplus: {
      online: "オンライン",
      gallery: "写真・動画を見る",
      addFavorite: "お気に入りに追加",
      removeFavorite: "お気に入りから外す",
      replyWaiting: "返信を待っています",
      replyNotify: "返信が来たら通知でお知らせします",
      enableNotify: "通知をオンにする",
      replyLater: "返信が来たらお知らせします。アプリを閉じても大丈夫です",
      bridgeTitle: "気が合ったらビデオで話そう",
      bridgeAvailable: (args: { name: string }) => `${args.name}さん今通話OK`,
      video: "ビデオ",
      voice: "音声",
      freeLeftPrefix: "無料で あと",
      freeLeftUnit: "通",
      /** 「無料で あと n通」の横に添える、通話リクエストへの誘い */
      callRequestHint: "通話のリクエストも送ってみよう",
      nameMeta: (args: { age: number | null; region: string | null }) =>
        [args.age, args.region].filter((v) => v !== null).join(" "),
    },
    send: "送信",
    callStarted: "通話を開始しました",
    callEnded: "通話が終了しました",
    missedCall: "不在着信",
    callCancelled: "発信キャンセル",
    callBack: "タップでかけ直す",
    videoCall: "ビデオ通話",
    voiceCall: "音声通話",
    voiceCallRequest: "音声通話リクエスト",
    videoCallRequest: "ビデオ通話リクエスト",
    loadEarlier: "過去のメッセージを読み込む",
    messageSend: "メッセージ送信",
    sendError: "送信に失敗しました",
    retry: "再送信",
    selectMedia: "画像・動画を選択",
    selectSticker: "スタンプを選択",
    closePanel: "パネルを閉じる",
    sticker: "スタンプ",
    stickerCategory: (args: { number: string | number }) =>
      `スタンプカテゴリ${args.number}`,
    stickerItem: (args: { number: string | number }) =>
      `スタンプ${args.number}`,
    confirmSendMedia: "この画像/動画を送信しますか？",
    image: "画像",
    video: "動画",
    errorMedia: "⚠︎お相手がメディアのアップロードに失敗しました。",
    viewImage: "画像を見る",
    viewVideo: "動画を見る",
    viewAudio: "音声を聞く",
    audio: "音声",
    playAudio: "再生",
    pauseAudio: "一時停止",
    seekAudio: "再生位置",
    block: "ブロックする",
    report: "通報する",
    blockSuccess: (args: { name: string | number }) =>
      `${args.name} をブロックしました`,
    reportSuccess: "通報しました",
    likePrompt: "気になったらいいねを送ろう",
    likeButton: "いいね！",
    bookmark: "お気に入り",
    liked: "いいね済み",
    introShowMore: "もっと見る",
    read: "既読",
    viewAllPhotos: "すべて見る",
    viewImages: "画像・動画一覧",
    startCallMenu: "通話する",
    openMenu: "メニューを開く",
    closeMenu: "メニューを閉じる",
    mediaMenuTitle: "写真・動画",
    mediaGalleryTitle: "送信された画像・動画",
    noMedia: "送信された画像・動画はありません",
    viewOtherGirls: "他の女の子の画像・動画見たい方はこちら",
    callFeeLabel: "通話料金",
    heldPointLabel: "保有ポイント",
    heldPointValue: (args: { point: string | number }) => `${args.point}P`,
    callPointPerMinute: (args: { point: string | number }) =>
      `${args.point}pt/1分`,
    ratePerMinute: (args: { point: string | number }) => `${args.point}P / 分`,
    callConfirmTitle: (args: { type: string | number }) =>
      `${args.type}を発信しますか？`,
    callConfirmAction: "発信",
    startCall: (args: { type: string | number }) => `${args.type}を発信`,
    requestCall: (args: { type: string | number }) =>
      `${args.type}をリクエスト`,
    callNotAccepting: "相手は通話を受け付けていません",
    voiceCallComingSoon: "音声通話は準備中です",
  },
  // チャットの pt 不足を先回りで知らせるモーダル（送信を待たずに購入導線を届ける）
  /** チャット pt不足の先回りモーダル（Waiting Card） */
  pointShortagePrompt: {
    /** 写真の上に弧で出す見出し。名前と「が待っています」で太さを変えるため分ける */
    waitingName: (args: { name: string | number }) => `${args.name}さん`,
    waitingSuffix: "が待っています",
    /** スクリーンリーダー向けのタイトル */
    title: (args: { name: string | number }) =>
      `${args.name}さんが待っています`,
    /** 相手の最後のメッセージが無いときに吹き出しへ出す代替の一言 */
    fallbackBubble: "ねぇ、まだ話したいな…",
    /** 自分側の吹き出し。返信がまだ届いていないことを見せる */
    myReplyBubble: "あなたの返信",
    /** CTA: 1回目コースをそのまま買う。pt は初回購入限定なら 1,000pt */
    cta: (args: { points: string | number }) => `${args.points}pt追加する`,
    /** CTA 上のバッジ: 買うポイントで送れる通数 */
    messagesBadge: (args: { count: string | number }) => `${args.count}通分`,
    /** CTA が作れないとき（プランが見つからない）の代替。チャージシートを開く */
    fallbackCta: "ポイントを追加する",
    /** CTA 下のリンク: 従来のチャージシート（プラン一覧）を開く */
    otherPlans: "ほかのプランを選ぶ",
    close: "閉じる",
    photoAlt: (args: { name: string | number }) => `${args.name}さんの写真`,
    /** 写真の左下に重ねる自分の写真（無ければこの文言を出す） */
    myPhotoLabel: "あなた",
  },
} as const;
